import { SIGNUP_MODAL_DEFAULT_VARIANT_IMAGERY_240806 } from "@faire/web-api/indigofair/settings/SIGNUP_MODAL_DEFAULT_VARIANT_IMAGERY_240806";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "./__internal__/getSetting";

export const getSettingSignUpModalDefaultVariantWithImagery = (): boolean =>
  getSettingValueWithoutAssignment(
    SIGNUP_MODAL_DEFAULT_VARIANT_IMAGERY_240806,
    false
  );

export const assignSettingSignUpModalDefaultVariantWithImagery = () => {
  assignSetting(SIGNUP_MODAL_DEFAULT_VARIANT_IMAGERY_240806);
};
